import React from "react";
const translate = require('../../translate');

const OccupancyHeaderPlain = ({ occupancy, language }) => {
    return <React.Fragment>
        <div className="card-title h5 text-center" style={{ fontSize: '500%' }}>
            {occupancy}
        </div>
        <div className="card-title text-center">
            {translate(language, 'shoppers in store')}
        </div>
    </React.Fragment>;
};

export default OccupancyHeaderPlain;